<template>
  <div v-if="isVisible" class="content_inner">
    {{ potltInfo.potltCd }} : {{ potltInfo.potltNm }}
    <br>

    <div v-for="item in potltData" :key="item.potltBannSno">
      {{ item.bannNm }} : {{ item.bannUrl }} : {{ item.scrptCntnt }}<br>
    </div>
  </div>
</template>
<script>

import { isEmpty } from 'lodash'
import commonMixin from '@/mixin/commonMixin'

export default {
  name: 'PopupBanner',
  components: {

  },
  mixins: [commonMixin],
  props: {
    potltInfo: {
      type: Object,
      default: null
    }
  },
  metaInfo () {

  },
  data () {
    return {
      isVisible: false,
      potltData: {} // 포틀릿 데이터
    }
  },
  computed: {

  },
  beforeUpdate () {

  },
  updated () {

  },
  created () {
    this.potltData = this.potltInfo.potltData
    if (!isEmpty(this.potltData)) this.isVisible = true
  },
  mounted () {
    // // 포틀릿 데이터 조회
    // this.$http.b2c.portletData(this, { potltCd: this.potltInfo.potltCd, potltNo: this.potltInfo.potltNo, langCd: this.getUserLangCd() } ).then( (result) => {
    //   const data = result.data
    //   if ( data.status === 'OK' ) {
    //     console.log('portletData', data)
    //     this.isVisible = true
    //     this.potltData = data.data
    //   } else {
    //     // 데이터 없음
    //   }
    // })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/PopupBanner.vue